import { headers } from 'services/auth'
import { getTransactionType } from 'utils/getTransactionType'
import axios from 'axios'

const API_URL = process.env.REACT_APP_API_URL
const REALTY_REPORT_DOWNLOAD = `${API_URL}/generatexls`

const REPORT_DOWNLOAD = `${API_URL}/upload/downloadpdf_relatorioimovel`
const EVALUATION_REPORT_DOWNLOAD = `${API_URL}/upload/downloadpdf_relatorioavaliacao`
const REPORT = `${API_URL}/upload/evaluation/`

export const downloadReport = data =>
  axios.post(REPORT_DOWNLOAD, JSON.stringify(data), {
    headers: {
      'Content-Type': 'application/json',
      ...headers(),
    },
    responseType: 'blob',
  })

export const downloadEvaluationReport = data =>
  axios.post(EVALUATION_REPORT_DOWNLOAD, JSON.stringify(data), {
    headers: {
      ...headers(),
      'Content-Type': 'application/json',
      Accept: 'application/xlsx',
    },
    responseType: 'blob',
  })

export const downloadRealtyReport = ({
  selectedItems,
  recentOnly,
  type,
  transaction,
}) => {
  let ids = selectedItems.map(item => String(item.Id))

  if (selectedItems.some(item => item.Similarity)) {
    ids = {}
    selectedItems.forEach(item => {
      ids[item.Id] = parseFloat(item.Similarity)
    })
  }

  const data = {
    ids,
    type,
    transaction:
      (transaction &&
        getTransactionType(transaction)
          .split('_')
          .pop()) ||
      undefined,
  }

  return axios.post(REALTY_REPORT_DOWNLOAD, data, {
    headers: {
      ...headers(),
      recent_only: recentOnly ? 1 : 0,
      Accept: 'application/xlsx',
    },
    responseType: 'blob',
  })
}

export const doReport = (data, get = false) =>
  get
    ? axios.get(`${REPORT}/${data.id}`, { headers: headers() })
    : axios.post(REPORT, data, { headers: headers() })
